<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon :color="statusColor" v-on="on">mdi-circle</v-icon>
    </template>
    <span>{{ statusLabel }}</span>
  </v-tooltip>
</template>

<script>
const THRESHOLD_DAYS = 30;

export default {
  props: ["item"],
  computed: {
    status() {
      const next = this.item.nextProofDate;
      if (!next) return "red";
      const now = Date.now();
      const diff = new Date(next).getTime() - now;
      const days = diff / (1000 * 60 * 60 * 24);
      if (days < 0) return "red";
      if (days <= THRESHOLD_DAYS) return "yellow";
      return "green";
    },
    statusColor() {
      return this.status === "green"
        ? "success"
        : this.status === "yellow"
          ? "warning"
          : "error";
    },
    statusLabel() {
      return this.$t(`proof.status.${this.status}`);
    },
  },
};
</script>
